module.exports = __webpack_public_path__ + "img/business_pic1.f8c20031.png";